app.controller("ChangePassWinController", ["$scope", "$state", "$http", "$uibModal", "AuthService", "params", "$uibModalInstance", "toastr",
    function ($scope, $state, $http, $uibModal, AuthService, params, $uibModalInstance, toastr) {
        $scope.oldPassword = "";
        $scope.newPassword = "";
        $scope.repeatNewPassword = "";
        $scope.email = null;
        $scope.type = params.type || null;
        $scope.passwordPattern = '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[\\*\\!\\@\\$\\%\\^\\&\\(\\)\\{\\}\\[\\]\\:\\;\\<\\>\\,\\.\\?\\/\\~\\_\\+\\-\\=\\|]).{8,50}$'

        AuthService.getUserData().then(function (data) {
            $scope.user = data;
            $scope.email = data.email
        });

        $scope.changePassword = function () {
            var fieldsAreFilled = $scope.oldPassword && $scope.newPassword && $scope.repeatNewPassword;
            var passwordsMatch = $scope.newPassword === $scope.repeatNewPassword;
            if (fieldsAreFilled && passwordsMatch && $scope.changePasswordForm.$valid) {
                if ($scope.newPassword === $scope.repeatNewPassword) {
                    AuthService.changePassword({
                        password: $scope.newPassword,
                        oldPassword: $scope.oldPassword
                    }).then(function () {
                        toastr.success('პაროლი შეცვლილია');
                        $uibModalInstance.close()
                    });
                } else toastr.error('', 'გთხოვთ სწორად გაიმეოროთ ახალი პაროლი');
            } else toastr.error('', 'გთხოვთ შეავსოთ ყველა ველი');
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
